import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  for: "checkbox",
  class: "switch-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args))),
      id: "checkbox",
      type: "checkbox",
      class: "switch-checkbox"
    }, null, 32),
    _createElementVNode("label", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "🌙", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, "☀️", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["switch-toggle", { 'switch-toggle-checked': _ctx.userTheme === 'dark-theme' }])
      }, null, 2)
    ])
  ]))
}